import { css } from "styled-components";

export const media = {
  forMobileOnly: (...args) => css`
    @media only screen and (max-width: 767px) {
      ${css(...args)};
    }
  `,
  forDesktopOnly: (...args) => css`
    @media only screen and (min-width: 768px) {
      ${css(...args)};
    }
  `
};



// WEBPACK FOOTER //
// ./src/styles/utils.js